const getCommonStyles = (theme) => ({
  sectionContainer: {
    padding: theme.spacing(14, 0, 14),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0),
    },
  },
  sectionTitle: {
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    zIndex: '10',
    position: 'relative',
    color: '#f8fdff',
    letterSpacing: '-0.02em',
    lineHeight: 1.1,
    marginBottom: theme.spacing(3),
    fontSize: '2.8rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.9rem',
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  sectionDescription: {
    zIndex: '10',
    position: 'relative',
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    color: '#b5c3d3',
    lineHeight: 1.9,
    fontSize: '1.15rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: 'justify',
    },
  },
});

export default getCommonStyles;
